module.exports = __webpack_public_path__ + "img/syria.a95fb1be.svg";